import { Post } from '@/@types/post'
import { MouseEvent } from 'react'
import { toRoutePathParam } from '../route'
import usePostDrawerOpener from './usePostDrawerOpener'
import useUniversalNavigate from './useUniversalNavigate'
import useUserPreference from './useUserPreference'

export default function usePostNavigator() {
	const navigate = useUniversalNavigate()
	const [isPostDetailSideSheetEnabled] = useUserPreference('isPostDetailSideSheetEnabled')
	const openPostDrawer = usePostDrawerOpener()

	const navigateToPost = (post: Post, e: MouseEvent) => {
		if (isPostDetailSideSheetEnabled) {
			openPostDrawer(post, e)
			return
		}

		navigate(
			{
				to: '/u/$username/$type/$id',
				params: {
					username: post.user!.username,
					type: toRoutePathParam(post.type),
					id: post.id,
				},
			},
			e
		)
	}

	return navigateToPost
}
